module.exports = require("core-js/modules/es.object.set-prototype-of");